// Source unique de verite : roles autorises a creer un client a la volee
// (aligne sur le garde-fou backend creerDevis ; comptable exclu).
export const CLIENT_CREATE_ROLES = ['admin', 'dg', 'cos', 'responsable_commercial'];

// Valeur vierge (factory -> pas de reference partagee entre instances)
export function emptyClientValue() {
  return {
    mode: 'existant',          // 'existant' | 'nouveau'
    client_id: '',
    nouveau_client: { raison_sociale: '', nom_contact: '', email: '', telephone: '', ville: '' },
  };
}

// Fragment de payload attendu par POST /devis (creerDevis)
export function clientPayload(value) {
  if (value?.mode === 'nouveau') return { nouveau_client: value.nouveau_client };
  return { client_id: value?.client_id || '' };
}

// Selection exploitable ? (client existant choisi OU raison sociale saisie)
export function clientValueValid(value) {
  if (!value) return false;
  if (value.mode === 'nouveau') return !!(value.nouveau_client?.raison_sociale || '').trim();
  return !!value.client_id;
}

// Selecteur de client controle, partageable. Le bouton "+ Nouveau client"
// est masque si le role n'autorise pas la creation (defense en profondeur cote UI ;
// le 403 backend reste la garantie reelle).
export default function ClientPicker({ clients = [], value, onChange, roles = [], required = true }) {
  const v = value || emptyClientValue();
  const canCreateClient = roles.some(r => CLIENT_CREATE_ROLES.includes(r));

  const setMode = (mode) => onChange({ ...v, mode });
  const setClientId = (client_id) => onChange({ ...v, client_id });
  const setNC = (patch) => onChange({ ...v, nouveau_client: { ...v.nouveau_client, ...patch } });

  return (
    <div>
      <label style={{ fontSize: 12, fontWeight: 600, color: '#333', marginBottom: 4, display: 'block' }}>
        Client {required ? '*' : ''}
      </label>

      {v.mode === 'existant' ? (
        <select className="gss-input" style={{ width: '100%' }} value={v.client_id}
                onChange={e => setClientId(e.target.value)} required={required}>
          <option value="">— Selectionner un client —</option>
          {clients.map(c => <option key={c.id} value={c.id}>{c.raison_sociale || c.nom}</option>)}
        </select>
      ) : (
        <input className="gss-input" style={{ width: '100%' }}
               placeholder="Raison sociale du nouveau client *"
               value={v.nouveau_client.raison_sociale}
               onChange={e => setNC({ raison_sociale: e.target.value })} required={required} />
      )}

      {canCreateClient && (
        <button type="button" className="gss-btn-sm" style={{ marginTop: 6 }}
                onClick={() => setMode(v.mode === 'existant' ? 'nouveau' : 'existant')}>
          {v.mode === 'existant' ? '+ Nouveau client' : '← Choisir un client existant'}
        </button>
      )}

      {v.mode === 'nouveau' && (
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginTop: 10 }}>
          <input className="gss-input" placeholder="Contact" value={v.nouveau_client.nom_contact}
                 onChange={e => setNC({ nom_contact: e.target.value })} />
          <input className="gss-input" type="email" placeholder="Email" value={v.nouveau_client.email}
                 onChange={e => setNC({ email: e.target.value })} />
          <input className="gss-input" placeholder="Téléphone" value={v.nouveau_client.telephone}
                 onChange={e => setNC({ telephone: e.target.value })} />
          <input className="gss-input" placeholder="Ville" value={v.nouveau_client.ville}
                 onChange={e => setNC({ ville: e.target.value })} />
        </div>
      )}
    </div>
  );
}
